import React from "react";

import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { useFormik } from "formik";
import * as Yup from "yup";

import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { LayoutForm } from "../../../components/Form/LayoutForm";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import api from "../../../service/api";
import { ButtunSubmit, Container, ContainerForm } from "../styles";

const CreateUser: React.FC = () => {
  const { addToast } = useToasts();
  const history = useHistory();

  async function handleSubmit(create: any) {
    try {
      const departamentalEvaluation = await api.post(
        "/departamental_evaluation",
        {
          title: create.title,
          qtd: create.qtd,
          date: create.date,
        }
      );

      addToast("Avaliação criado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push(`/avaliacao/${departamentalEvaluation.data.id}`);
    } catch (error: any) {
      if (!error.response) {
        return addToast(
          "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }

      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }
  const formik = useFormik({
    initialValues: {
      title: undefined,
      qtd: undefined,
      date: undefined,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Titulo é obrigatório"),
      date: Yup.string().required("Data é obrigatória"),
    }),
    onSubmit: (data) => handleSubmit(data),
  });
  return (
    <Container>
      <PanelAndDetailAndCreateHeader
        title={"Criar Avaliação departamental"}
        goBack
      />
      <ContainerForm>
        <LayoutForm onSubmit={formik.handleSubmit}>
          <GroupInput>
            <Input
              label="Título"
              {...formik.getFieldProps("title")}
              error={
                formik.touched.title && formik.errors.title
                  ? formik.errors.title
                  : undefined
              }
            />
            <Input
              type="date"
              label="Data de encerramento"
              {...formik.getFieldProps("date")}
              error={
                formik.touched.date && formik.errors.date
                  ? formik.errors.date
                  : undefined
              }
            />
          </GroupInput>

          <ButtunSubmit type="submit"> Criar </ButtunSubmit>
        </LayoutForm>
      </ContainerForm>
    </Container>
  );
};

export default CreateUser;
